export const USER_GROUPS = {
  SUPER_ADMIN: 'super_admin',
  ORGANIZATION_ADMIN: 'organization_admin',
  COUNTRY_ADMIN: 'country_admin',
  CLINIC_ADMIN: 'clinic_admin',
  THERAPIST_ADMIN: 'therapist_admin',
  REGIONAL_ADMIN: 'regional_admin',
  TRANSLATOR: 'translator',
  PATIENT: 'patient',
  PHC_SERVICE_ADMIN: 'phc_service_admin',
  PHC_WORKER: 'phc_worker',
  THERAPIST: 'therapist',
};

export const USER_ROLES = {
  ORGANIZATION_ADMIN: 'organization_admin',
  GLOBAL_ADMIN: 'global_admin',
  COUNTRY_ADMIN: 'country_admin',
  CLINIC_ADMIN: 'clinic_admin',
  MANAGE_ORGANIZATION_ADMIN: 'manage_organization_admin',
  MANAGE_GLOBAL_ADMIN: 'manage_global_admin',
  MANAGE_COUNTRY_ADMIN: 'manage_country_admin',
  MANAGE_CLINIC_ADMIN: 'manage_clinic_admin',
  MANAGE_THERAPIST: 'manage_therapist',
  MANAGE_PHC_WORKER: 'manage_phc_worker',
  MANAGE_PATIENT: 'manage_patient',
  SETUP_CATEGORY: 'setup_category',
  SETUP_EXERCISE: 'setup_exercise',
  SETUP_EDUCATIONAL_MATERIAL: 'setup_educational_material',
  SETUP_QUESTIONNAIRE: 'setup_questionnaire',
  VIEW_REPORT: 'view_report',
  VIEW_TREATMENT_DETAIL: 'view_treatment_detail',
  VIEW_APPOINTMENT: 'view_appointment',
  ARRANGE_APPOINTMENT: 'arrange_appointment',
  CREATE_TREATMENT_PLAN_FOR_PATIENT: 'create_treatment_plan_for_patient',
  VIEW_EXERCISE: 'view_exercise',
  VIEW_EDUCATIONAL_MATERIAL: 'view_educational_material',
  VIEW_QUESTIONNAIRE: 'view_questionnaire',
  SUBMIT_EXERCISE_RESULT: 'submit_exercise_result',
  SUBMIT_QUESTIONNAIRE_ANSWER: 'submit_questionnaire_answer',
  VIEW_GOAL_PROGRESS: 'view_goal_progress',
  INPUT_GOAL_PROGRESS: 'input_goal_progress',
  MESSAGE_CALL_BETWEEN_THERAPIST_PATIENT: 'message_call_between_therapist_patient',
  VIEW_EDIT_OWN_PROFILE: 'view_edit_own_profile',
  MANAGE_ORGANIZATION: 'manage_organization',
  VIEW_MANAGE_ORGANIZATION: 'view_organization',
  MANAGE_ASSISTIVE_TECHNOLOGY: 'manage_assistive_technology',
  MANAGE_COUNTRY: 'manage_country',
  MANAGE_TRANSLATION: 'manage_translation',
  MANAGE_SYSTEM_LIMIT: 'manage_system_limit',
  MANAGE_TERM_CONDITION: 'manage_term_condition',
  MANAGE_PRIVACY_POLICY: 'manage_privacy_policy',
  MANAGE_CLINIC: 'manage_clinic',
  MANAGE_PHC_SERVICE: 'manage_phc_service',
  MANAGE_PROFESSION: 'manage_profession',
  MANAGE_LANGUAGE: 'manage_language',
  MANAGE_FAQ_STATIC_PAGE: 'manage_faq_static_page',
  MANAGE_ABOUT_US_STATIC_PAGE: 'manage_about_us_static_page',
  MANAGE_GUIDANCE_PAGE: 'manage_guidance_page',
  MANAGE_DISEASE: 'manage_disease',
  VIEW_TERM_CONDITION: 'view_term_condition',
  VIEW_PRIVACY_POLICY: 'view_privacy_policy',
  MANAGE_COLOR_SCHEME: 'manage_color_scheme',
  MANAGE_TRANSLATOR: 'manage_translator',
  MANAGE_EMAIL_TEMPLATE: 'manage_email_template',
  TRANSLATE_TRANSLATION: 'translate_translation',
  TRANSLATE_EDUCATIONAL_MATERIAL: 'translate_educational_material',
  TRANSLATE_EXERCISE: 'translate_exercise',
  TRANSLATE_QUESTIONNAIRE: 'translate_questionnaire',
  TRANSLATE_GUIDANCE_PAGE: 'translate_guidance_page',
  TRANSLATE_PRIVACY_POLICY: 'translate_privacy_policy',
  TRANSLATE_SURVEY: 'translate_survey',
  TRANSLATE_STATIC_PAGE: 'translate_static_page',
  TRANSLATE_TERM_CONDITION: 'translate_term_condition',
  TRANSLATE_CATEGORY: 'translate_category',
  TRANSLATE_ASSISTIVE_TECHNOLOGY: 'translate_assistive_technology',
  TRANSLATE_SCREENING_QUESTIONNAIRE: 'translate_screening_questionnaire',
  TRANSLATE_HEALTH_CONDITION: 'translate_health_condition',
  TRANSLATE_EMAIL_TEMPLATE: 'translate_email_template',
  VIEW_DASHBOARD: 'view_dashboard',
  SUPER_ADMIN: 'super_admin',
  MANAGE_SURVEY: 'manage_survey',
  MANAGE_SCREENING_QUESTIONNAIRE: 'manage_screening_questionnaire',
  DOWNLOAD_SURVEY: 'download_survey',
  MANAGE_HEALTH_CONDITION: 'manage_health_condition',
  MANAGE_MFA_POLICY: 'manage_mfa_policy',
  MANAGE_REGION: 'manage_region',
  MANAGE_PROVINCE: 'manage_province',
  MANAGE_PHC_SERVICE_ADMIN: 'manage_phc_service_admin',
  MANAGE_REGIONAL_ADMIN: 'manage_regional_admin',
  MANAGE_PATIENT_REFERRAL: 'manage_patient_referral',
  MANAGE_DOWNLOAD_TRACKER: 'manage_download_tracker',
  VIEW_PROFESSION: 'view_profession',
  VIEW_CLINIC_LIST: 'view_clinic_list',
  VIEW_PROVINCE_LIST: 'view_province_list',
  MANAGE_PHC_WORKER_GUIDANCE: 'manage_phc_worker_guidance',
  TRANSLATE_PHC_WORKER_GUIDANCE: 'translate_phc_worker_guidance',
  MANAGE_API_CLIENT: 'manage_api_client',
  VIEW_DEFAULT_LIMITED_PATIENT: 'view_default_limited_patient',
  VIEW_EXERCISE_LIST: 'view_exercise_list',
  VIEW_EDUCATIONAL_MATERIAL_LIST: 'view_educational_material_list',
  VIEW_QUESTIONNAIRE_LIST: 'view_questionnaire_list',
  VIEW_AUDIT_LOG: 'view_audit_log',
  VIEW_THERAPIST_LIST: 'view_therapist_list',
  VIEW_PHC_WORKER_LIST: 'view_phc_worker_list',
  DELETE_THERAPIST: 'delete_therapist',
  DELETE_PHC_WORKER: 'delete_phc_worker',
  MANAGE_GLOBAL_PATIENT: 'manage_global_patient',
  VIEW_CATEGORY_LIST: 'view_category_list',
  VIEW_REGION_LIST: 'view_region_list',
  VIEW_PHC_SERVICE_LIST: 'view_phc_service_list',
  SUBMIT_SURVEY: 'submit_survey',
  SKIP_SURVEY: 'skip_survey',
};

export const SETTING_ROLES = [
  USER_ROLES.MANAGE_COUNTRY,
  USER_ROLES.MANAGE_LANGUAGE,
  USER_ROLES.MANAGE_TRANSLATION,
  USER_ROLES.MANAGE_SYSTEM_LIMIT,
  USER_ROLES.MANAGE_PROVINCE,
  USER_ROLES.MANAGE_CLINIC,
  USER_ROLES.MANAGE_PHC_SERVICE,
  USER_ROLES.MANAGE_PROFESSION,
  USER_ROLES.MANAGE_FAQ_STATIC_PAGE,
  USER_ROLES.MANAGE_ABOUT_US_STATIC_PAGE,
  USER_ROLES.MANAGE_TERM_CONDITION,
  USER_ROLES.MANAGE_PRIVACY_POLICY,
  USER_ROLES.MANAGE_GUIDANCE_PAGE,
  USER_ROLES.MANAGE_ORGANIZATION,
  USER_ROLES.TRANSLATE_TRANSLATION,
  USER_ROLES.TRANSLATE_STATIC_PAGE,
  USER_ROLES.TRANSLATE_PRIVACY_POLICY,
  USER_ROLES.TRANSLATE_GUIDANCE_PAGE,
  USER_ROLES.MANAGE_SURVEY,
  USER_ROLES.MANAGE_HEALTH_CONDITION,
  USER_ROLES.MANAGE_PROVINCE,
  USER_ROLES.MANAGE_SURVEY
];
